export default __webpack_public_path__ + "static/media/oppa_sheet.a11c890b.png";